import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';

import {
  AddArchiveScreen,
  AlertsAllScreen,
  AlertsScreen,
  BulkPayInstallmentsScreen,
  ChangePasswordScreen,
  ContractAnalyzingScreen,
  ContractDetailsScreen,
  ContractEditScreen,
  ContractListScreen,
  ContractReviewScreen,
  EmailScreen,
  HomeScreen,
  InstallmentDetailsScreen,
  LoginScreen,
  MarketOverviewScreen,
  MarketSettingsScreen,
  NotificationScreen,
  PinScreen,
  ProfileScreen,
  QuoteDetailsScreen,
  RegisterScreen,
  ReportScreen,
  Splashscreen,
  SubscribeScreen,
  UpdatePasswordScreen,
  UpdateProfileScreen,
  FinanciamentoCalculatorScreen,
  AuthenticatedFinanciamentoCalculatorScreen,
  VerifyEmailScreen,
} from '~/screens';

import AppShell from './AppShell';
import WhatsappView from '~/screens/Whatsapp/view';
import ProtectedRoute, { AuthOnlyRoute } from './ProtectedRoute';

export default function Routes() {
  return (
    <RouterRoutes>
      <Route path="/" element={<Splashscreen />} />
      <Route path="/financeiro/calculadora" element={<FinanciamentoCalculatorScreen />} />
      <Route path="/verify-email" element={<VerifyEmailScreen />} />

      <Route
        path="/auth/login"
        element={
          <AuthOnlyRoute>
            <LoginScreen />
          </AuthOnlyRoute>
        }
      />
      <Route
        path="/auth/register"
        element={
          <AuthOnlyRoute>
            <RegisterScreen />
          </AuthOnlyRoute>
        }
      />
      <Route
        path="/auth/recovery/email"
        element={
          <AuthOnlyRoute>
            <EmailScreen />
          </AuthOnlyRoute>
        }
      />
      <Route
        path="/auth/recovery/pin"
        element={
          <AuthOnlyRoute>
            <PinScreen />
          </AuthOnlyRoute>
        }
      />
      <Route
        path="/auth/recovery/new-password"
        element={
          <AuthOnlyRoute>
            <ChangePasswordScreen />
          </AuthOnlyRoute>
        }
      />

      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="home" replace />} />
        <Route path="home" element={<HomeScreen />} />
        <Route path="alerts" element={<AlertsScreen />} />
        <Route path="alerts/all" element={<AlertsAllScreen />} />
        <Route path="alerts/bulk-pay" element={<BulkPayInstallmentsScreen />} />
        <Route path="add" element={<AddArchiveScreen />} />
        <Route path="reports" element={<ReportScreen />} />
        <Route path="ferramentas/calculadora" element={<AuthenticatedFinanciamentoCalculatorScreen />} />
        <Route path="profile" element={<ProfileScreen />} />
        <Route path="whatsapp" element={<WhatsappView />} />
        <Route path="subscribe" element={<SubscribeScreen />} />
        <Route path="profile/update" element={<UpdateProfileScreen />} />
        <Route path="profile/password" element={<UpdatePasswordScreen />} />
        <Route path="contracts" element={<ContractListScreen />} />
        <Route path="contracts/:id" element={<ContractDetailsScreen />} />
        <Route path="contracts/:id/edit" element={<ContractEditScreen />} />
        <Route
          path="contracts/:id/installments/bulk-pay"
          element={<BulkPayInstallmentsScreen />}
        />
        <Route
          path="contracts/:id/installments/:installmentId"
          element={<InstallmentDetailsScreen />}
        />
        <Route path="contracts/analyzing" element={<ContractAnalyzingScreen />} />
        <Route path="contracts/review" element={<ContractReviewScreen />} />
        <Route path="market" element={<MarketOverviewScreen />} />
        <Route path="market/settings" element={<MarketSettingsScreen />} />
        <Route path="market/:product" element={<QuoteDetailsScreen />} />
        <Route path="notifications" element={<NotificationScreen />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </RouterRoutes>
  );
}
